<template>
<v-container>
  <Tabs v-if="showHeader" :settings="tabSettings"></Tabs>
  <transition name="fade" mode="out-in">
    <router-view></router-view>
  </transition>
</v-container>
  
</template>

<script>
import Tabs from '@/components/Tabs'
import routes from '@/route_names'
export default {
  name: 'Insights',
  components: {
    Tabs
  },
  data(){
    return {
      showHeader: !this.routeContains(routes.INSIGHTS_METRICS)
    }
  },
  computed: {
    tabSettings: function() {
      const tabs = []
      
        tabs.push({
          id: routes.INSIGHTS,
          label: 'Insights'
        })
      return {
        preselected: null,
        tabs: tabs
      }
    }
  },
  watch: {
    $route: function(to, from) {
      this.showHeader = !this.routeContains(routes.INSIGHTS_METRICS)
    }
  },
}
</script>

<style></style>
